import { useState } from "react";
import "./changepassword.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import logoImage from "../../assets/logo_trucktronix.png";
import { serviceUpdateAdminPassword } from "../../api/serviceFleetMaster";

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  //show password
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const navigate = useNavigate();

  const email = sessionStorage.getItem("org_email");
  const adminId = sessionStorage.getItem("id") || "";

  const busy = loading;

  const goBackHandler = () => {
    window.history.back();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (busy) return;

    if (newPassword !== confirmPassword) {
      toast.error("New and confirm password don't match!");
      return;
    }

    try {
      setLoading(true);
      
      const response = await serviceUpdateAdminPassword({
          pwd: currentPassword.trim(),
          updatePwd: newPassword.trim(),
        });

      if (response.message) {
        toast.success(response.message);
        navigate("/my-profile");
        return;
      }

      // if (response.status === 400) toast.error("Invalid user data.");
      // else if (response.status === 404)
      //   toast.error("User doesn't exist in the system.");
      // else toast.error("Password change invalid");
    } catch (error) {
      console.error(error.message);
      // toast.error(error.message);
      toast.error("An error occurred during password change.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cp-page">
      <header className="cp-header">
        <button
          type="button"
          className="cp-btn cp-btn-ghost"
          onClick={goBackHandler}
          disabled={busy}
          title="Go back"
        >
          <i className="bi bi-arrow-left" aria-hidden="true" />
          Back
        </button>

        <div className="cp-header-right">
          <div className="cp-title">
            <div className="cp-title-main">Change Password</div>
            <div className="cp-title-sub">{email || "—"}</div>
          </div>
          <img src={logoImage} alt="Trucktronix" className="cp-logo" />
        </div>
      </header>

      <main className="cp-main">
        <div className="cp-card">
          <div className="cp-card-top">
            <div className="cp-chip">
              <i className="bi bi-shield-lock" aria-hidden="true" />
              Security
            </div>
            <div className="cp-muted">{loading ? "Updating…" : " "}</div>
          </div>

          <form className="cp-form" onSubmit={handleSubmit}>
            <div className="cp-field">
              <label className="cp-label" htmlFor="cp-current">
                Current password
              </label>
              <div className="cp-input-wrap">
                <input
                  id="cp-current"
                  className="cp-input"
                  type={showCurrent ? "text" : "password"}
                  required
                  placeholder="Current Password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  disabled={busy}
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="cp-eye"
                  onClick={() => setShowCurrent((v) => !v)}
                  tabIndex={-1}
                  aria-label={showCurrent ? "Hide password" : "Show password"}
                >
                  <i
                    className={`bi ${showCurrent ? "bi-eye" : "bi-eye-slash"}`}
                  />
                </button>
              </div>
            </div>

            <div className="cp-grid">
              <div className="cp-field">
                <label className="cp-label" htmlFor="cp-new">
                  New password
                </label>

                <div className="cp-input-wrap">
                  <input
                    id="cp-new"
                    className="cp-input"
                    type={showNew ? "text" : "password"}
                    required
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    disabled={busy}
                    autoComplete="new-password"
                  />
                  <button
                    type="button"
                    className="cp-eye"
                    onClick={() => setShowNew((v) => !v)}
                    tabIndex={-1}
                    aria-label={showNew ? "Hide password" : "Show password"}
                  >
                    <i
                      className={`bi ${showNew ? "bi-eye" : "bi-eye-slash"}`}
                    />
                  </button>
                </div>
              </div>

              <div className="cp-field">
                <label className="cp-label" htmlFor="cp-confirm">
                  Confirm new password
                </label>

                <div className="cp-input-wrap">
                  <input
                    id="cp-confirm"
                    className="cp-input"
                    type={showConfirm ? "text" : "password"}
                    required
                    placeholder="Confirm New Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    disabled={busy}
                    autoComplete="new-password"
                  />
                  <button
                    type="button"
                    className="cp-eye"
                    onClick={() => setShowConfirm((v) => !v)}
                    tabIndex={-1}
                    aria-label={showConfirm ? "Hide password" : "Show password"}
                  >
                    <i
                      className={`bi ${showConfirm ? "bi-eye" : "bi-eye-slash"}`}
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="cp-actions">
              <button
                className="cp-btn cp-btn-primary"
                type="submit"
                disabled={busy}
              >
                <i className="bi bi-check2-circle" aria-hidden="true" />
                <span>{loading ? "Changing…" : "Change Password"}</span>
              </button>

              <button
                className="cp-btn cp-btn-ghost"
                type="button"
                onClick={goBackHandler}
                disabled={busy}
              >
                <i className="bi bi-x-circle" aria-hidden="true" />
                <span>Cancel</span>
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}

export default ChangePassword;
